// Set dynamic meta tags and document properties from environment variables
import { env } from '../env';

export const setDynamicMetaTags = () => {
  // Handle safe-area divs and Cordova for mobile
  if (env.VITE_APP_TYPE === 'mobile') {
    const topBar = document.querySelector('.safe-area-top-bar') as HTMLElement;
    const bottomBar = document.querySelector('.safe-area-bottom-bar') as HTMLElement;
    if (topBar) {
      topBar.style.display = 'block';
    }
    if (bottomBar) {
      bottomBar.style.display = 'block';
    }

    // Load Cordova script for mobile only
    const cordovaScript = document.createElement('script');
    cordovaScript.type = 'text/javascript';
    cordovaScript.src = 'cordova.js';
    cordovaScript.onerror = () => console.log('Cordova not available');
    document.body.appendChild(cordovaScript);
  } else {
    const topBar = document.querySelector('.safe-area-top-bar') as HTMLElement;
    const bottomBar = document.querySelector('.safe-area-bottom-bar') as HTMLElement;
    if (topBar) {
      topBar.style.display = 'none';
    }
    if (bottomBar) {
      bottomBar.style.display = 'none';
    }
  }
};
